import OwlCarousel from "react-owl-carousel";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { getTrans as T } from "../../../../Shared/Language";
import { GetCelebration } from "../../Celebrations/Celebration-Service/CelebrationService";
import { useCallback, useContext, useEffect, useState } from "react";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import { TostMsg } from "../../../../App";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { LazyImage } from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
const defaultImage = "/images/placeholder_profile.png";
const Celebrations = () => {
  let toster = useContext(TostMsg);
  const [carouselKey, setCarouselKey] = useState(0);
  const [workAnniversary, setWorkAnniversary] = useState([]);
  const [marriageAnniversary, setMarriageAnniversary] = useState([]);
  const [birthday, setBirthday] = useState([]);
  const [Isloading, setIsloading] = useState(true);
  const history = useHistory();
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  useEffect(() => {
    getCelebration(1);
    getCelebration(2);
    getCelebration(3);
  }, []);

  async function getCelebration(type) {
    setIsloading(true);
    const params = {
      OrgId: userDetails.OrgId,
      KeyId: type,
      PageNumber: 1,
      PageSize: 5,
    };
    try {
      const response = await GetCelebration(params);
      let CelebrationList = response?.data;
      setCarouselKey((prevKey) => prevKey + 1);
      if (type == 2) {
        setMarriageAnniversary(CelebrationList?.Data);
      } else if (type == 3) {
        setBirthday(CelebrationList?.Data);
      } else if (type == 1) {
        setWorkAnniversary(CelebrationList?.Data);
      }
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DashboardCelebration);
    }
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const navigatePage = (event) => {
    history.push(`/Celebrations`);
  };

  return (
    <>
      <div className="col-xl-12 owl-co owl-co2 col-sm-6 col-md-12">
        <div className="card birthday">
          <div className="card-body">
            <div className="custom-tab-1 custom-tab-11">
              <div className="">
                <strong className="upcome">{T("Upcoming Birthdays")}</strong>
                <Link to="Celebrations" className="more-icon">
                  <i className="fa fa-angle-right"></i>
                </Link>
                {Isloading ? (
                  <Skeleton height={100} width="100%" style={{ marginBottom: "15px" }}/>
                ) : birthday?.length == 1 ? (
                  <div className="boxs boxs2">
                    {birthday.length == 1 ? (
                      birthday?.map((occassion, Index) => (
                        <div
                          onClick={() => navigatePage(occassion)}
                          className="item"
                          key={Index}
                        >
                          <div className="image-content">
                            <img
                              className="img"
                              src={occassion?.ProfileImage || defaultImage}
                              onError={handleImageError}
                              alt=""
                            />
                            <div className="pos-img">
                              <img
                                src="/images/org-img/awards/celebration.svg"
                                alt="Celebration"
                              />
                            </div>
                          </div>
                          <p className="detailed-text">
                            {occassion?.Name}
                            <br />
                            <b className="b-color">{occassion?.CelebratedOn}</b>
                          </p>
                        </div>
                      ))
                    ) : (
                      <OwlCarousel
                        key={carouselKey}
                        items={1}
                        className="owl-theme"
                        loop
                        autoPlay={true}
                        nav={false}
                        dots={true}
                        margin={8}
                        autoplayTimeout={3000}
                        autoplayHoverPause={true}
                      >
                        {birthday?.map((occassion, Index) => (
                          <div
                            onClick={() => navigatePage(occassion)}
                            className="item"
                            key={Index}
                          >
                            <div className="image-content">
                              <img
                                className="img"
                                src={occassion?.ProfileImage || defaultImage}
                                onError={handleImageError}
                                alt=""
                              />
                              <div className="pos-img">
                                <img
                                  src="/images/org-img/awards/celebration.svg"
                                  alt="Celebration"
                                />
                              </div>
                            </div>
                            <p className="detailed-text">
                              {occassion?.Name}
                              <br />
                              <b className="b-color">
                                {occassion?.CelebratedOn}
                              </b>
                            </p>
                          </div>
                        ))}
                      </OwlCarousel>
                    )}
                  </div>
                ) : (
                  <div className="boxs boxs2">
                    <OwlCarousel
                      key={carouselKey}
                      items={2}
                      className="owl-theme"
                      loop
                      autoplay={true}
                      autoplayTimeout={3000}
                      autoplayHoverPause={true}
                      nav={false}
                      dots={true}
                      margin={8}
                    >
                      {birthday?.map((occassion, Index) => (
                        <div
                          className="item"
                          key={Index}
                          onClick={() => navigatePage(occassion)}
                        >
                          <div className="image-content">
                            <img
                              className="img"
                              src={occassion?.ProfileImage || defaultImage}
                              onError={handleImageError}
                            />
                            <div className="pos-img">
                              <img
                                src="/images/org-img/awards/celebration.svg"
                                alt="Celebration"
                              />
                            </div>
                          </div>
                          <p className="detailed-p-text">
                            {occassion?.Name}
                          </p>
                            <span className="b-color">{occassion?.CelebratedOn}</span>
                        </div>
                      ))}
                    </OwlCarousel>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xl-12 owl-co owl-co2 col-sm-6 col-md-12">
        <div className="card anni">
          <div className="card-body">
            <div className="custom-tab-1 custom-tab-11">
              <div className="">
                <strong className="upcome">
                  {T("Upcoming Work-Anniversaries")}
                </strong>
                <Link to="Celebrations" className="more-icon">
                  <i className="fa fa-angle-right"></i>
                </Link>
                {Isloading ? (
                  <Skeleton height={100} width="100%" style={{ marginBottom: "15px" }}/>
                ) : workAnniversary?.length == 1 ? (
                  <div className="boxs boxs2">
                    {workAnniversary.length == 1 ? (
                      workAnniversary?.map((occassion, index) => (
                        <div
                          className="item"
                          key={index}
                          onClick={() => navigatePage(occassion)}
                        >
                          <div className="image-content">
                            <img
                              className="img"
                              src={occassion?.ProfileImage || defaultImage}
                              onError={handleImageError}
                            />
                            <div className="pos-img">
                              <img src="/images/no-data-found/work-anniversary-dummy.png" />
                            </div>
                          </div>
                          <p className="detailed-text">
                            {occassion?.Name}
                            <br />
                            <b className="b-color">{occassion?.CelebratedOn}</b>
                          </p>
                        </div>
                      ))
                    ) : (
                      <OwlCarousel
                        key={carouselKey}
                        items={1}
                        className="owl-theme"
                        loop
                        autoPlay={true}
                        nav={false}
                        dots={true}
                        margin={8}
                        autoplayTimeout={3000}
                        autoplayHoverPause={true}
                      >
                        {workAnniversary?.map((occassion, index) => (
                          <div className="item" key={index}>
                            <div className="image-content">
                              <img
                                className="img"
                                src={occassion?.ProfileImage || defaultImage}
                                onError={handleImageError}
                              />
                              <div className="pos-img">
                                <img
                                  src="/images/no-data-found/work-anniversary-dummy.png"
                                  alt=""
                                />
                              </div>
                            </div>
                            <p className="detailed-text">
                              {occassion?.Name}
                              <br />
                              <b className="b-color">
                                {occassion?.CelebratedOn}
                              </b>
                            </p>
                          </div>
                        ))}
                      </OwlCarousel>
                    )}
                  </div>
                ) : (
                  <div className="boxs boxs2">
                    <OwlCarousel
                      key={carouselKey}
                      items={2}
                      className="owl-theme"
                      loop
                      autoplay={true}
                      autoplayTimeout={3000}
                      autoplayHoverPause={true}
                      nav={false}
                      dots={true}
                      margin={8}
                    >
                      {workAnniversary?.map((occassion, index) => (
                        <div
                          className="item"
                          key={index}
                          onClick={() => navigatePage(occassion)}
                        >
                          <div className="image-content">
                            <img
                              className="img"
                              src={occassion?.ProfileImage || defaultImage}
                              onError={handleImageError}
                            />
                            <div className="pos-img">
                              <img src="/images/no-data-found/work-anniversary-dummy.png" />
                            </div>
                          </div>
                          <p className="detailed-p-text">
                            {occassion?.Name}
                          </p>
                            <span className="b-color">{occassion?.CelebratedOn}</span>
                        </div>
                      ))}
                    </OwlCarousel>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xl-12 owl-co owl-co2 col-sm-6 col-md-12">
        <div className="card anni">
          <div className="card-body">
            <div className="custom-tab-1 custom-tab-11">
              <strong className="upcome">
                {T("Upcoming Marriage Anniversaries")}
              </strong>
              <Link to="Celebrations" className="more-icon">
                <i className="fa fa-angle-right"></i>
              </Link>
              {Isloading ? (
                <Skeleton height={100} width="100%" style={{ marginBottom: "15px" }}/>
              ) : marriageAnniversary?.length == 1 ? (
                <div className="boxs boxs2">
                  {marriageAnniversary.length == 1 ? (
                    marriageAnniversary?.map((occassion, index) => (
                      <div
                        className="item"
                        key={index}
                        onClick={() => navigatePage(occassion)}
                      >
                        <div className="image-content">
                          <img
                            className="img"
                            src={occassion?.ProfileImage || defaultImage}
                            onError={handleImageError}
                          />
                          <div className="pos-img">
                            <img src="/images/no-data-found/wedding-anniversary-dummy.png" />
                          </div>
                        </div>
                        <p className="detailed-p-text">{occassion?.Name}</p>

                        <b className="b-color">{occassion?.CelebratedOn}</b>
                      </div>
                    ))
                  ) : (
                    <OwlCarousel
                      key={carouselKey}
                      items={2}
                      className="owl-theme"
                      loop
                      autoplay={true}
                      autoplayTimeout={3000}
                      autoplayHoverPause={true}
                      nav={false}
                      dots={true}
                      margin={8}
                    >
                      {marriageAnniversary?.map((occassion, index) => (
                        <div
                          className="item"
                          key={index}
                          onClick={() => navigatePage(occassion)}
                        >
                          <div className="image-content">
                            <img
                              className="img"
                              src={occassion?.ProfileImage || defaultImage}
                              onError={handleImageError}
                            />
                            <div className="pos-img">
                              <img src="/images/no-data-found/wedding-anniversary-dummy.png" />
                            </div>
                          </div>
                          <p className="detailed-p-text">{occassion?.Name}</p>

                          <b className="b-color">{occassion?.CelebratedOn}</b>
                        </div>
                      ))}
                    </OwlCarousel>
                  )}
                </div>
              ) : (
                <div className="boxs boxs2">
                  <OwlCarousel
                    key={carouselKey}
                    items={2}
                    className="owl-theme"
                    loop
                    autoplay={true}
                    autoplayTimeout={3000}
                    autoplayHoverPause={true}
                    nav={false}
                    dots={true}
                    margin={8}
                  >
                    {marriageAnniversary?.map((occassion, index) => (
                      <div
                        className="item"
                        key={index}
                        onClick={() => navigatePage(occassion)}
                      >
                        <div className="image-content">
                          <img
                            className="img"
                            src={occassion?.ProfileImage || defaultImage}
                            onError={handleImageError}
                          />
                          <div className="pos-img">
                            <img src="/images/no-data-found/wedding-anniversary-dummy.png" />
                          </div>
                        </div>
                        <p className="detailed-p-text">
                          {occassion?.Name}
                        </p>
                          <span className="b-color">{occassion?.CelebratedOn}</span>
                        
                      </div>
                    ))}
                  </OwlCarousel>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Celebrations;
